import CentralApiService from "../../centralApiServices";


class CadastroProdutoService extends CentralApiService {

    constructor() {
        super('/api/cadastroProduto')
    }

    saveTipoProduto(tipoProduto){
        return this.post(`/saveTipoProduto`, tipoProduto)
    }

    saveTipoEstoque(tipoEstoque){
        return this.post(`/saveTipoEstoque`, tipoEstoque)
    }

}

export default CadastroProdutoService